import React from 'react';
import classnames from 'classnames';

import { Progress } from 'uikit/progress';

import styles from '../styles/videosCardMedia.module.scss';

const VideosCardMedia = ({
  videoType,
  isComplete,
  image,
  cardMedia,
  progress,
  duration,
}) => (
  <div className={classnames(styles.element, styles[`media_${videoType}`], { [styles.isComplete]: isComplete })}>
    <figure className={classnames(styles.figure, { [styles[`default-${videoType}`]]: !image })}>
      {image && <img src={image} alt="" />}
    </figure>
    {cardMedia}
    {videoType === 'video' && !isComplete && Boolean(progress) && duration > 0 && (
      <Progress
        value={((100 * progress) / duration)}
        color="primary"
        className={styles.progress}
      />
    )}
  </div>
);

VideosCardMedia.propTypes = {};

export default VideosCardMedia;
